function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: ",
        ";\n  border: 1.5px solid ",
        ";\n  border-radius: 0.75rem;\n  background: var(--theme-input-bg, #fff);\n  color: var(--theme-text, #111827);\n  font-size: 1rem;\n  line-height: 1.5;\n  box-sizing: border-box;\n  resize: vertical;\n  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  outline: none;\n  &:focus {\n    border-color: var(--theme-primary, #3b82f6);\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n  }\n  &:disabled {\n    background: var(--theme-input-disabled-bg, #f3f4f6);\n    color: var(--theme-text-disabled, #a1a1aa);\n    cursor: not-allowed;\n  }\n  &::placeholder {\n    color: var(--theme-text-placeholder, #9ca3af);\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: 0.85rem;\n  top: ",
        ";\n  transform: translateY(0);\n  font-size: ",
        ";\n  color: ",
        ";\n  background: var(--theme-input-bg, #fff);\n  padding: 0 0.25rem;\n  pointer-events: none;\n  transition: top 0.2s ease-in-out, font-size 0.2s ease-in-out, color 0.2s ease-in-out;\n  z-index: 2;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.85rem;\n  color: var(--theme-error, #ef4444);\n  margin-top: 0.1rem;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.8rem;\n  color: ",
        ";\n  margin-left: auto;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState } from 'react';
import styled from '@emotion/styled';
// 스타일 컴포넌트 (Input.tsx의 스타일과 유사하게 정의)
var TextareaContainer = styled.div(_templateObject(), function(param) {
    var $fullWidth = param.$fullWidth;
    return $fullWidth ? '100%' : 'auto';
});
var StyledTextarea = styled.textarea(_templateObject1(), function(param) {
    var $hasLabel = param.$hasLabel;
    return $hasLabel ? '1.6rem 0.75rem 0.5rem 0.75rem' : '0.75rem 0.75rem 0.5rem 0.75rem';
}, function(param) {
    var $hasError = param.$hasError;
    return $hasError ? 'var(--theme-error, #ef4444)' : 'var(--theme-border, #d1d5db)';
});
var FloatingLabel = styled.label(_templateObject2(), function(param) {
    var $focused = param.$focused, $hasValue = param.$hasValue;
    return $focused || $hasValue ? '0.32rem' : '1.1rem';
}, function(param) {
    var $focused = param.$focused, $hasValue = param.$hasValue;
    return $focused || $hasValue ? '0.78rem' : '1rem';
}, function(param) {
    var $focused = param.$focused, $hasValue = param.$hasValue, $hasError = param.$hasError;
    return $hasError ? 'var(--theme-error, #ef4444)' : $focused || $hasValue ? 'var(--theme-primary, #3b82f6)' : 'var(--theme-text-placeholder, #9ca3af)';
});
var ErrorMessage = styled.div(_templateObject3());
var CharacterCount = styled.div(_templateObject4(), function(param) {
    var $hasError = param.$hasError;
    return $hasError ? 'var(--theme-error, #ef4444)' : 'var(--theme-text-placeholder, #a1a1aa)';
});
/**
 * 기본 텍스트 영역 컴포넌트
 */ var Textarea = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var className = _param.className, label = _param.label, error = _param.error, _param_fullWidth = _param.fullWidth, fullWidth = _param_fullWidth === void 0 ? false : _param_fullWidth, _param_showCharacterCount = _param.showCharacterCount, showCharacterCount = _param_showCharacterCount === void 0 ? false : _param_showCharacterCount, maxLength = _param.maxLength, value = _param.value, required = _param.required, id = _param.id, placeholder = _param.placeholder, props = _object_without_properties(_param, [
        "className",
        "label",
        "error",
        "fullWidth",
        "showCharacterCount",
        "maxLength",
        "value",
        "required",
        "id",
        "placeholder"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), isFocused = _useState[0], setIsFocused = _useState[1];
    var hasValue = value != null && value !== '';
    var currentLength = typeof value === 'string' ? value.length : 0;
    var textareaId = id || (label ? "textarea-".concat(label) : undefined);
    // label이 있으면 placeholder를 숨김
    var textareaPlaceholder = label ? '' : placeholder;
    return /*#__PURE__*/ React.createElement(TextareaContainer, {
        $fullWidth: fullWidth
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(StyledTextarea, _object_spread_props(_object_spread({
        id: textareaId,
        className: className,
        $hasError: !!error,
        $fullWidth: fullWidth,
        $hasLabel: !!label,
        value: value,
        maxLength: maxLength,
        required: required,
        placeholder: textareaPlaceholder,
        onFocus: function() {
            return setIsFocused(true);
        },
        onBlur: function() {
            return setIsFocused(false);
        }
    }, props), {
        ref: ref
    })), label && /*#__PURE__*/ React.createElement(FloatingLabel, {
        htmlFor: textareaId,
        $focused: isFocused,
        $hasValue: hasValue,
        $hasError: !!error
    }, label, required && /*#__PURE__*/ React.createElement("span", {
        style: {
            color: 'var(--theme-error, #ef4444)'
        }
    }, "*"))), error && /*#__PURE__*/ React.createElement(ErrorMessage, null, error), showCharacterCount && maxLength && /*#__PURE__*/ React.createElement(CharacterCount, {
        $hasError: !!error
    }, currentLength, " / ", maxLength));
});
Textarea.displayName = 'Textarea';
export { Textarea };
export default Textarea;
